import { useState, useEffect, useCallback } from 'react';
import useLoadedLanguages from './useLoadedLanguages';
import { useTranslation } from 'react-i18next';

export default function useCurrentLanguage() {
  const { i18n } = useTranslation();

  const [eventLang, setEventLang] = useState();
  const languages = useLoadedLanguages();
  const [language, setLanguage] = useState();

  const handleLanguageChange = useCallback((lng) => {
    setEventLang(lng);
  }, []);

  useEffect(() => {
    if (!i18n) {
      console.error(
        'i18n instance not set. Call init() before using any components',
      );
      setLanguage(() => ({ tag: 'de', data: {} }));
      return;
    }

    i18n?.on('languageChanged', handleLanguageChange);

    if (languages) {
      for (const [tag, data] of Object.entries(languages)) {
        if (tag === i18n.languages[0]) {
          setLanguage({ tag: tag, ...data });
        }
      }
    }

    return () => {
      i18n?.off('languageChanged', handleLanguageChange);
    };
  }, [languages, eventLang, handleLanguageChange, i18n]);

  return language;
}
